import { PlanId } from 'domains/models/subscription/planId';
import { PlanVersion } from 'domains/models/subscription/planVersion';
import SubscriptionFeature from 'domains/models/subscription/features';

export default class CalendarIntegrationFeature extends SubscriptionFeature {
  canAdd(planId: PlanId, count: number) {
    return this.maxCount(planId) > count;
  }

  maxCount(planId: PlanId) {
    switch (planId) {
      case PlanId.Free:
        return 3;
      case PlanId.Pro:
        return 3;
      case PlanId.Team:
      case PlanId.Enterprice:
        return 6;
      default:
        return 3;
    }
  }
}
